module.exports = __webpack_public_path__ + "static/media/AboutPage__Cerissa.1da3d73b.png";